var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.7"},[React.createElement("path",{"d":"M7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8V11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11V8Z","fill":"#E8EFFF","key":0}),React.createElement("path",{"d":"M8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55229 6 9 5.55228 9 5C9 4.44772 8.55229 4 8 4Z","fill":"#E8EFFF","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z","fill":"#E8EFFF","key":2})]));
}

InfoIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
